const tc_acc = document.querySelectorAll(".custom-accodion-page-content-item-title");
tc_acc.forEach(item => {
    item.addEventListener("click", function() {
        console.log(this);
        if (item.classList.contains("open")) {
            item.classList.remove("open");
            return;
        }
        tc_acc.forEach(tc_btn => {
            tc_btn.classList.remove("open");
        })
        item.classList.add("open");
        // item.nextElementSibling.style.display = "dis?"
    })
})
